import React from 'react';
// import {ConsentError, shouldShowConsentError} from '~/components/BillingEligibility/ConsentError';
import Button from '@mui/material/Button';
export const ReviewDaysAmount = ({ patient }) => {
    console.log('patient: ');
    console.log(patient);
    const days = patient.reviewDaysAmount?.count || 0;
    // if (shouldShowConsentError(patient)){
    //   return <ConsentError patient={patient} isDataDays={true}/>;
    // }
    if (!patient.lastReport) {
        return React.createElement("div", { className: "text-center", style: { marginLeft: 'auto' } },
            React.createElement(Button, { style: { fontFamily: 'Barlow', color: '#00000099', borderRadius: 16, fontWeight: '700', fontSize: 'xx-small', cursor: 'auto', backgroundColor: 'transparent' }, color: "inherit", size: "small" }, "0 days"));
    }
    return (React.createElement("div", { className: "text-center", style: { marginLeft: 'auto' } },
        React.createElement(Button, { style: { fontFamily: 'Barlow', color: '#00000099', borderRadius: 16, fontWeight: '700', fontSize: 'xx-small', cursor: 'auto', backgroundColor: 'transparent' }, color: "inherit", size: "small" },
            days,
            " ",
            days === 1 ? 'day' : 'days')));
};
